import $ from 'jquery';

class SearchModal {
  constructor() {
    this.searchButton = $('.js-search-button');
    this.searchModal = $('.js-search-modal');

    if (!this.searchButton.length || !this.searchModal.length) {
      return;
    }

    this.init();
  }

  init() {
    this.searchButton.on('click', () => {
      this.searchModal
        .css({ opacity: 0 })
        .addClass('active')
        .stop()
        .animate(
          {
            opacity: 1,
          },
          300,
        );
    });

    this.searchModal.on('click', '.js-search-modal-close', () => {
      this.searchModal.stop().animate(
        {
          opacity: 0,
        },
        300,
        () => {
          this.searchModal.removeClass('active');
        },
      );
    });
  }
}

export default new SearchModal();



// WEBPACK FOOTER //
// ./src/scripts/modules/search-modal.js